import { useEffect, useState } from 'react';
import { EventObject, Interpreter, State } from 'xstate';
import { equals } from 'lodash/fp';

export function serviceSubscription<T, TContext, TSchema = any, TEvent extends EventObject = any>(service: Interpreter<TContext, TSchema, TEvent>, selector: (state: State<TContext, TEvent, TSchema>) => T, callback: (value: T) => void) {
  let previousValue = selector(service.initialState);

  return service.subscribe(state => {
    const currentValue = selector(state);
    if (!equals(previousValue)(currentValue)) {
      callback(currentValue);
      previousValue = currentValue;
    }
  });
}

export default function useServiceSelector<T, TContext, TSchema = any, TEvent extends EventObject = any>(service: Interpreter<TContext, TSchema, TEvent>, selector: (state: State<TContext, TEvent, TSchema>) => T) {
  const [state, setState] = useState<T>(selector(service?.initialState));

  useEffect(() => {
    const { unsubscribe } = serviceSubscription(service, selector, setState);

    return unsubscribe;
  }, [service, selector]);

  return state;
}
